import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import {fieldIssueTypesType} from '../../constants/proptype-validation';
import {formatSubtypeDisplayValue} from '../../utils/issueTypes-helpers';
import SelectBoxAdapter from './SelectBoxAdapter';

const findOptionFromSingleSelectionPrefixList = function find(id, singleSelectionPrefixList = []) {
  return singleSelectionPrefixList.find(opt => opt.value === id);
};

const formatsingleSelectionPrefixListLabel = function format(id, singleSelectionPrefixList = []) {
  const selected = findOptionFromSingleSelectionPrefixList(id, singleSelectionPrefixList);
  return selected && selected.label;
};

const IssueTypeSelectDropdown = ({
  className,
  disabled,
  selectedOptionId,
  activeIssueSubTypesGroupedDropdownOptions,
  onChange,
  dropdownMaxWidth,
  clearable,
  valid,
  fieldIssueTypeEntitiesMap,
  scrollableContainer,
  singleSelectionPrefixList
}) => (
  <SelectBoxAdapter
    className={className}
    options={activeIssueSubTypesGroupedDropdownOptions}
    selectedOptions={(selectedOptionId && findOptionFromSingleSelectionPrefixList(selectedOptionId, singleSelectionPrefixList)) ||
      fieldIssueTypeEntitiesMap[selectedOptionId] ||
      undefined}
    valueRenderer={id =>
      formatsingleSelectionPrefixListLabel(id, singleSelectionPrefixList) ||
      formatSubtypeDisplayValue(id, fieldIssueTypeEntitiesMap)}
    disabled={disabled}
    onChange={onChange}
    clearable={clearable}
    valid={valid}
    grouped
    searchable
    searchIcon
    searchPlaceholder={i18n.t('new.search')}
    dropdownMaxWidth={dropdownMaxWidth}
    scrollableContainer={scrollableContainer}
    singleSelectionPrefixList={singleSelectionPrefixList}
  />
);

IssueTypeSelectDropdown.displayName = 'IssueCreateFormSelectDropdown';

IssueTypeSelectDropdown.defaultProps = {
  dropdownMaxWidth: 250
};

IssueTypeSelectDropdown.propTypes = {
  className: PropTypes.string,
  selectedOptionId: PropTypes.string,
  activeIssueSubTypesGroupedDropdownOptions: PropTypes.array.isRequired,
  fieldIssueTypeEntitiesMap: fieldIssueTypesType.isRequired,
  disabled: PropTypes.bool,
  dropdownMaxWidth: PropTypes.number,
  clearable: PropTypes.bool,
  valid: PropTypes.bool,
  scrollableContainer: PropTypes.object,
  singleSelectionPrefixList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  ),
  onChange: PropTypes.func.isRequired
};

export default IssueTypeSelectDropdown;
